import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError} from 'rxjs';

import * as moment from 'moment-timezone';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { DownloadService } from 'src/app/shared/download.service';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
import { InvoiceComponent } from 'src/app/transactions/invoice/invoice.component';
import { InitialState } from 'src/app/store/reducer';
import { Store } from '@ngrx/store';
import { OpenAdvanceSearchModal } from 'src/app/transactions/store/actions';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CookiesService } from 'src/app/shared/cookies.service';
import { GlobalData } from 'src/app/shared/services/globla-data';

@Component({
	selector: 'app-big-query',
	templateUrl: './big-query.component.html',
	styleUrls: ['./big-query.component.scss']
})
export class BigQueryComponent implements OnInit {
	  misReportFilterForm: FormGroup;
		@ViewChild('searchButton',{static:true}) searchButton : ElementRef;
		minDate = "2023-04-01"
		showIframe : boolean = false;
	  maxDate = moment().format('YYYY-MM-DD')
	  clientArr: any = []
	  keyword = 'name';
	  dateFormat = 'YYYY-MM-DD';
	  isLocaleDateFormat: boolean = true;
	  safeSheetUrl!: SafeResourceUrl;
		adminUrl: string = ''
		isOsakaAdmin: boolean = false
		BranchAccess: boolean = false;
		ConsolidateAccess :boolean = false;
		showMessage:boolean=false;
	alertType:String="";
	message:String=""
	// private readonly publishUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQyCSwGLRa4eCnbsmfxgLqSMdcCtUpHe8QmBJeYcsrlJvtsP74zHk2OQ1Pf8wu2JcyXh0c9XFIHbtDy/pubhtml?widget=true&headers=false';
	  publishUrl = '';
	
	  safeUrl!: SafeResourceUrl;
	constructor(
		private httpClient: HttpClient,
		private formBuilder: FormBuilder,
		public commonService: CommonServiceService,
		private cookiesService: CookiesService,
		private sanitizer: DomSanitizer,
		private spinner: NgxSpinnerService,
		private route: ActivatedRoute,
		private router: Router,
		private downloadService: DownloadService,
		private tabService: TabService,
		private store: Store<InitialState>,
	) {

		this.store.select('sharedReducers').subscribe((items)=>{
				if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
							this.minDate = items.financeYear.start_date
							this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
										moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
						} else {
							let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
							if(!current_financial_year) {
								current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
							}
							this.minDate = current_financial_year.start_date
							this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
										moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
						}	  
					})
	}

	async ngOnInit() {

	this.misReportFilterForm = this.formBuilder.group({
		start_date: [this.minDate, this.checkDate('start_date')],
		end_date: [this.maxDate, this.checkDate('end_date')],
	});
	this.setFormData()
	
	let globalSettingConfig = this.commonService.globalSettingConfig;
	if(!globalSettingConfig || globalSettingConfig.length == 0) {
		globalSettingConfig = await this.commonService.getGlobalSettings();
	}
	let report_config = globalSettingConfig.filter(el=>el.group=='REPORT')
	if(report_config && report_config.length>0){
		console.log("report_config[0].json_doc",report_config[0].json_doc["value"])
		let branch_config = report_config[0].json_doc["value"].filter(el=>el.key=='DATA URL')
		if(branch_config && branch_config.length){
			this.publishUrl = branch_config[0].value
		}
		let consolidate_config = report_config[0].json_doc["value"].filter(el=>el.key=='CONSOLIDATE DATA URL')
		if(consolidate_config && consolidate_config.length){
			this.adminUrl = consolidate_config[0].value
		}
	}

	let dateConfig = await this.commonService.getDateFormat('date_format')
	this.dateFormat = dateConfig.dateFormat
	this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
	let accessData = localStorage.getItem('accessData') ? JSON.parse(localStorage.getItem('accessData')) : null
	accessData = accessData ? accessData : GlobalData.getAccessData();
	if(accessData == undefined) {
		if (localStorage.getItem('okountUserInfo') != null && localStorage.getItem('okountUserInfo') != undefined) {
			let userInfo = JSON.parse(localStorage.getItem('okountUserInfo'))
			accessData = await this.commonService.getFeatureData(userInfo.roles[0].roleid)
		}
	}
	console.log("accessData",accessData)
	this.ConsolidateAccess = this.checkAccess(accessData? accessData.features : undefined,'Consolidate Report')
	// if(this.ConsolidateAccess) this.adminUrl=   'https://docs.google.com/spreadsheets/d/1ck8IKDd5yWwhXT6utUt9jntDeUKq-5ANIRu6lzXBfz8/edit?usp=sharing'

	this.BranchAccess = this.checkAccess(accessData? accessData.features : undefined,'Branch Report')
	}


	checkAccess(json,key){
		let Analysis = json.filter(el=>el.feature_name=="Analysis")
		console.log("Analysis",Analysis)
		if(Analysis && Analysis.length>0){
			let reportArr = Analysis[0].sub_features.filter(el=>el.feature_name=="Report Designer")
			console.log("reportArr",reportArr)
			if(reportArr && reportArr.length>0){
				let report = reportArr[0].sub_features.filter(el=>el.feature_name==key)
				return report && report.length>0 && report[0].access==true ? true : false
			}
		}
	}

	checkDate(formControlName){
		return (control: AbstractControl) => {
			let valid = true
			if(!moment(control.value, 'YYYY-MM-DD').isValid()) {
				valid = false
			} else {
				if(this){
					if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
						valid = false
					}
				}
			}
			return !valid ? {[formControlName]: {value: control.value}} : null;
		};
	}
	
	setFormData() {
	let queryParams = localStorage.getItem('activeBigQuerySearchQueryParams')
	if (queryParams != null) {
		let parsedParams = JSON.parse(queryParams)
		
		if (parsedParams.start_date != "") {
		this.misReportFilterForm.controls.start_date.setValue(moment(parsedParams.start_date).format('YYYY-MM-DD') )
		}
		if (parsedParams.end_date != "") {
		this.misReportFilterForm.controls.end_date.setValue(moment(parsedParams.end_date).format('YYYY-MM-DD'))
		}
	}
	}


	openInNewTab() {
	window.open(this.publishUrl, '_blank'); 
	}

	openConsolidateInNewTab(){
		window.open(this.adminUrl, '_blank'); 
	}

	search(_: any) {
		GlobalVariable.openModalStatus = false;

	this.safeSheetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.publishUrl);
	this.showIframe = true;
	}

	searchCOnsolidate() {
		GlobalVariable.openModalStatus = false;

	this.safeSheetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.adminUrl);
	this.showIframe = true;
	}



	updateRealTime() {
		this.spinner.show()
		const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		this.commonService.postRequest(`${environment.okountUrl}/big_query/sync`,{}).subscribe((res:any) =>{
			this.showMessage = true;
			this.alertType = 'success-box'
			this.message = res.message
			console.log('res',res)	
	   })

	}

	getFilteredData(queryParams) {
	this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/reports/gst`, queryParams).subscribe(res => {
		console.log(res);
	}, err => {
		console.error(err);
	})
	}

	reset() {
	GlobalVariable.openModalStatus = false;
	this.misReportFilterForm = this.formBuilder.group({
		start_date: [''],
		end_date: [''],
	})
	localStorage.removeItem('activeBigQuerySearchQueryParams')
	}

	clickSearchButton(){
			this.search(this.misReportFilterForm.value);

	}

	hideError(){
		this.showMessage = false
	}
	
	}
		
		
